import { createContext, useReducer, useEffect } from 'react'

export const AuthContext = createContext()

export const authReducer = (state, action) => {
    switch (action.type) {
        case 'LOGIN': 
            return { 
                ...state, //preserves isLoading state also, otherwise will be overwritten
                user: action.payload 
            }
        case 'LOGOUT':
            return { 
                ...state,
                user: null 
            }
        case 'UPDATE_LOADING':
            return { 
                ...state,
                isLoading: action.payload 
            }
        default:
            return state
    }

}

export const AuthContextProvider = ( {children} ) => {
    const [state, dispatch] = useReducer(authReducer, {  //authReducer is function to interact with state
        user: null,  //initial state
        isLoading: true
    })

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}/api/user/user-data`, {
                    credentials: 'include'
                })
                if (!res.ok) {
                    dispatch({type: 'LOGOUT'})
                    return
                }
                const data = await res.json()
                dispatch({type: 'LOGIN', payload: data.userData})
            } catch (error) {
                dispatch({type: 'LOGOUT'})
            } finally {
                dispatch({type: 'UPDATE_LOADING', payload: false})
            }
        }
        fetchUser()
    }, [])

    console.log('AuthContext state: ', state)

    return (
        <AuthContext.Provider value={{...state, dispatch}}>
            { children }
        </AuthContext.Provider>
    )
}